import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { Institute } from '@lyceo/homi/shared/util-models';

export const INSTITUTE_FEATURE_KEY: string = 'institute';

export type InstituteState = EntityState<Institute>;

export const instituteAdapter: EntityAdapter<Institute> =
  createEntityAdapter<Institute>();

export const initialInstituteState: InstituteState =
  instituteAdapter.getInitialState();

const reducer: ActionReducer<InstituteState, Action> = createReducer(
  initialInstituteState,
);

export function instituteReducer(
  state: InstituteState | undefined,
  action: Action,
): InstituteState {
  return reducer(state, action);
}
